"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
exports.osmosysCanvasReducer = (state, { type, data }) => {
    switch (type) {
        case 'update':
            return Object.assign(Object.assign({}, state), data);
        case 'meta':
            return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), data) });
        case 'prefs':
            return Object.assign(Object.assign({}, state), { prefs: Object.assign(Object.assign({}, state.prefs), data) });
        case 'state':
            return Object.assign(Object.assign({}, state), { state: Object.assign(Object.assign({}, state.state), data) });
        case 'ready':
            return Object.assign(Object.assign({}, state), { ready: !!data });
        case 'canvasQueries':
            return Object.assign(Object.assign({}, state), { canvasQueries: Object.assign(Object.assign({}, state.canvasQueries), data) });
        default:
            throw new Error(`${type} is not a valid reducer option`);
    }
};
exports.useOsmosysCanvasReducer = (initialState) => {
    return react_1.useReducer(exports.osmosysCanvasReducer, initialState);
};
//# sourceMappingURL=osmosysCanvasReducer.js.map